import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { DashboardService } from 'app/main/services/dashboard.service';
import { User } from 'app/auth/models';

@Component({
  selector: 'app-program-list',
  templateUrl: './program-list.component.html',
  styleUrls: ['./program-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProgramListComponent implements OnInit {

  @Output() selectEvent = new EventEmitter<{type: string, value: any}>();

  public availableOptions: any;
  public localProgram: number;

  constructor(private _list: DashboardService) { }

  public onModelChange(event: any, id: string): void {
    this.selectEvent.emit({
      type: id,
      value: event
    });
  }

  private getListData() {
    this._list.postProgramList().subscribe(
      (res: any) => {
        this.availableOptions = res.data;
        this.localProgram = res.data[0];
        this.onModelChange(this.localProgram, 'referencial');
      },
      (err: any) => {
        console.error(err);
      }
    )
  }

  ngOnInit(): void {
    this.getListData();
  }

}
